import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import HelpModal from './HelpModal';
import { DetailsPill } from './SettingDetails';
import './ToggleSwitch.css';

const ToggleSwitch = ({
  name,
  value,
  checked,
  label,
  onChange,
  helpTitle,
  helpDescription,
  disabled = false,
  description,
  details,
  showOnOffText = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames('ToggleSwitch', name)}>
      <span className="toggle-switch-label">{label}</span>
      {helpTitle && helpDescription && <HelpModal title={helpTitle} description={helpDescription} />}
      <span className="switch-container">
        <label className={`switch ${showOnOffText ? 'with-text' : ''}`}>
          <input type="checkbox" name={name} onChange={onChange} checked={checked} value={value} disabled={disabled} />
          <span className="slider round">
            {showOnOffText && <span className="slider-text">{checked ? t('common.on') : t('common.off')}</span>}
          </span>
        </label>
      </span>
      {description && (
        <small className="toggle-switch-description">
          {description}
          {details && <DetailsPill title={label} details={details} />}
        </small>
      )}
    </div>
  );
};

ToggleSwitch.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  helpTitle: PropTypes.string,
  helpDescription: PropTypes.string,
  disabled: PropTypes.bool,
  description: PropTypes.string,
  /** Long-form copy behind a pill on the description line, as markdown — see src/content/details */
  details: PropTypes.string,
  showOnOffText: PropTypes.bool,
};

export default ToggleSwitch;
